<template>
  <v-app id="calculator">
    <v-layout>
      <v-flex xs12 sm8 offset-sm2 box>
        <v-card>
          <v-card-title>
            <div>
              <h1 class="headline mb-3">{{ heading }}</h1>
              <div> {{ instruction }} </div>
            </div>
          </v-card-title>

          <v-img
            src="fig.jpeg"
            aspect-ratio="3.75"
            contain
          >
          </v-img>

          <v-form action="" ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex xs3 sm3 d-flex>
                  <v-text-field
                    label="Observed AAT Level"
                    placeholder="00.00"
                    hint="Enter Observed AAT level (mg/dL)"
                    outline
                    clearable
                    v-model="calculator.maat"
                    :rules="maatRules"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs3 sm3 d-flex>
                  <v-text-field
                    label="CRP Level"
                    placeholder="00.00"
                    hint="Enter CRP level (mg/L)"
                    outline
                    clearable
                    v-model="calculator.crp"
                    :rules="crpRules"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs3 sm3>
                  <v-select
                    outline
                    Default
                    item_text="name"
                    item_value="value"
                    :items="calculator.genotypes"
                    label="Genotype"
                    v-model="calculator.genotype.name"
                    :rules="genotypeRules"
                    clearable
                  ></v-select>
                </v-flex>

                <v-flex xs2 sm2 md2>
                  <v-card-actions>
                    <v-btn
                      outline round
                      color="indigo"
                      class="mx-0 mt-3"
                      @click.prevent="calculate"
                      :disabled="!valid"
                    >
                    <v-icon>done_all</v-icon>
                      Calculate
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                  <v-text-field
                    box
                    label="x"
                    placeholder="x"
                    v-model="result.x"
                    v-if='checkbox'
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs4 sm4 md4>
                  <v-text-field
                    box
                    label="y"
                    placeholder="y"
                    v-model="result.y"
                    v-if='checkbox'
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs4 sm4 md4>
                  <v-text-field
                    box
                    label="Residual AAT Level"
                    placeholder="Residual AAT Level"
                    v-model="result.residual_aat"
                    v-if='checkbox'
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    box
                    label="Predicted AAT Level (mg/dL)"
                    placeholder="Adjusted AAT"
                    v-model="result.adjusted_aat"
                  >
                  </v-text-field>
                </v-flex>
                <v-checkbox
                  v-model="checkbox"
                  label="Show intermediate results"
                >
                </v-checkbox>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      maatRules: [
        v => !!v || 'Observed AAT Level is required',
        v => !isNaN(v) || 'Observed AAT Level must be a number',
        v => v > 0.0|| 'Observed AAT Level must be positive'
      ],
      crpRules: [
        v => !!v || 'CRP Level is required',
        v => !isNaN(v) || 'CRP Level must be a number',
        v => v > 0.0|| 'CRP Level must be positive'
      ],
      genotypeRules: [
        v => !!v || 'Genotype must be selected'
      ],
      heading: 'AAT LEVEL PREDICTOR',
      instruction: 'Calculate Predicted AAT from Observed AAT and CRP.',
      calculator: {
        genotypes: ['PI*MM', 'PI*MS', 'PI*MZ', 'PI*MF', 'PI*SS', 'PI*SZ', 'PI*ZZ'],
        maat: '',
        crp: '',
        genotype: {
            name: ''
        }
      },
      result: {
        x: 0.0,
        y: 0.0,
        residual_aat: 0.0,
        adjusted_aat: 0.0
      },
      valid: true,
      checkbox: true
    }
  },
  methods: {
    setError(error, text) {
      this.error = (error.response && error.response.data && error.response.data.error) || text
    },
    validate () {
      this.$refs.form.validate()
    },
    calculate() {
      if (!this.valid){
        return
      }

      this.$http.plain
        .post('/api/v1/calculators', {
            calculator: {
              maat: this.calculator.maat,
              crp: this.calculator.crp,
              genotype: this.calculator.genotype.name
            }
        })
        .then(response => {
          this.result = response.data
        })
        .catch(error => {
          this.calculator.adjusted_aat = error.data;
          this.setError(error, 'Cannot calculate Predicted AAT')
        })
    }
  }
}
</script>